module.exports = __webpack_public_path__ + "officialStatic/img/gxjdLogo.cebf6dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/gxjdLogo.png
// module id = 0F0k
// module chunks = 0